import { REGIONS_WITHOUT_WE_SKI } from 'ots-constants';

export const isRegionWithoutWeSki = (locale: string, regionId: string) => (
  REGIONS_WITHOUT_WE_SKI.some((region) => region.locale === locale && region.regionId === regionId)
);
